import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import GameScratch from './views/gamescratch'
import ImageViewer from './views/imageviewer'
import Login from './views/login/Login'
import PageNext from './views/pagenext'
import Prizedraw from './views/prizedraw'
import Register from './views/register/Register'

type ProtectedRouteProps = {
  children: any;
};

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = localStorage.getItem('isAuthenticated');

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
}

export function AppRoutes() {
  const isMainDomain = window.location.hostname === 'raspadinha.quantictechnology.com.br';

  return (
    <Router>
      <Routes>
        {isMainDomain ? (
          <>
            {/* Suporte para path parameters */}
            <Route path="/:id/:hash" element={<ImageViewer />} />

            {/* Suporte para query string */}
            <Route path="/" element={<ImageViewer />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route
              path="/next/*"
              element={
                <ProtectedRoute>
                  <PageNext />
                </ProtectedRoute>
              }
            />
            <Route
              path="/register/*"
              element={
                <ProtectedRoute>
                  <Register />
                </ProtectedRoute>
              }
            />
            <Route
              path="/scratch/*"
              element={
                <ProtectedRoute>
                  <GameScratch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/prizedraw/*"
              element={
                <ProtectedRoute>
                  <Prizedraw />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}
